import { mapNamesToSubtestIds } from './'

/**
 * Adds answersByItem to the userAssessment, which provides the selected answer for each item
 * @param {object} uA the userAssessment 
 * @returns {object} the userAssessment with answersByItem added
 */
export default function addAnswersByItem(uA) {
  const subtestIds = mapNamesToSubtestIds(uA)
  const subjects = ['English', 'Math', 'Reading', 'Science']

  function computeAnswersByItem(uA, subtestId) {
    const activities = Object.values(uA.activity[subtestId])
    let answersByItem = {}
    activities.forEach(activity => {
      if (!activity.response) return
      answersByItem[activity.itemId] = activity.response
    })
    return answersByItem
  }

  // generate answersByItem for each subtest
  let answersByItem = {}
  subjects.forEach(subject => {
    const subtestId = subtestIds[subject]
    answersByItem[subtestId] = computeAnswersByItem(uA, subtestId)
  })
  
  // return the uA with answersByItem added
  return {
    ...uA,
    answersByItem,
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/addAnswersByItem.js